import React from "react";
import LegalPage from "./LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage
      seoTitle="Refund Policy"
      seoDescription="HelloSir.ai refund and cancellation policy — clear, fair rules for top-up credits, free trials, accidental purchases and service interruptions. A Cloud Lab Technologies (UK) product."
      seoKeywords={["hellosir.ai refund policy", "AI chatbot refund", "SaaS credit refund", "cancellation policy", "Cloud Lab Technologies"]}
      path="/refund-policy"
      tagline="// money matters"
      heading="Refund Policy"
    >
      <p>
        We want you to feel confident every time you top up. This Refund Policy ("Policy") explains when refunds are available, how to request one,
        and how long it takes. HelloSir.ai is a product of <a href="https://www.cloudlabweb.com" target="_blank" rel="noopener noreferrer"><strong>Cloud Lab Technologies (UK)</strong></a>.
      </p>

      <h2>1. Free trial</h2>
      <p>
        Every new account starts on a free trial with no card required. You only pay if you choose to purchase a top-up pack. There is nothing to refund
        during the free trial.
      </p>

      <h2>2. Pay-as-you-go top-up packs</h2>
      <p>
        Top-up packs (chat, web voice, AI calling, extra agents) are charged upfront and credited to your account instantly. The packs are non-subscription,
        non-renewing and credits never expire.
      </p>

      <h2>3. 7-day cooling-off (unused credits)</h2>
      <p>
        If you change your mind within <strong>7 days</strong> of purchase and you have <strong>not consumed any portion of the credits</strong> in the
        pack, we will refund the pack in full to the original payment method.
      </p>

      <h2>4. Partial usage</h2>
      <p>
        Once credits have been consumed (even partially), the pack is considered "in use" and is non-refundable. You can stop using HelloSir at any time
        and any remaining credits stay available on your account for future use.
      </p>

      <h2>5. Duplicate / accidental charges</h2>
      <p>
        We always refund duplicate or clearly accidental charges within 5 business days, no questions asked. Open a ticket from{" "}
        <a href="/contact">our contact page</a> with the transaction reference.
      </p>

      <h2>6. Service interruption</h2>
      <p>
        If a verified platform-wide outage caused by HelloSir lasts longer than 24 consecutive hours, we will issue a pro-rated service credit (not a cash
        refund) equal to the affected portion of your most recent pack.
      </p>

      <h2>7. Non-refundable cases</h2>
      <ul>
        <li>Credits that have been consumed.</li>
        <li>Charges older than 90 days.</li>
        <li>Account suspended for violation of our <a href="/terms">Terms & Conditions</a>.</li>
        <li>Costs incurred with upstream telecom providers (e.g. inbound carrier minutes via VAPI / Twilio) that have already been settled.</li>
      </ul>

      <h2>8. How to request a refund</h2>
      <ol>
        <li>Email <a href="mailto:billing@hellosir.ai">billing@hellosir.ai</a> with the subject <em>"Refund request"</em>.</li>
        <li>Include your account email, transaction reference and reason.</li>
        <li>Our team responds within 2 business days.</li>
        <li>Approved refunds arrive within 5–10 business days, depending on your bank.</li>
      </ol>
    </LegalPage>
  );
}
